"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatChannel(object) {
    return checkExternalChatChannel(object).fulfilled;
}
exports.isExternalChatChannel = isExternalChatChannel;
function checkExternalChatChannel(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasChoice("source", ["internal", "external"]).optional(), __1.hasString("externalId").optional(), __1.hasString("name").nonEmpty(), __1.hasArray("usersActive", __1.isString()), __1.hasArray("usersFormer", __1.isString()), __1.hasArray("access", __1.isString())).withOptions(options).explain();
}
exports.checkExternalChatChannel = checkExternalChatChannel;
//# sourceMappingURL=ExternalChatChannel.js.map